import { render, staticRenderFns } from "./ActiviteComponent.vue?vue&type=template&id=875d7f10&scoped=true&"
import script from "./ActiviteComponent.vue?vue&type=script&lang=js&"
export * from "./ActiviteComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActiviteComponent.vue?vue&type=style&index=0&id=875d7f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875d7f10",
  null
  
)

export default component.exports